import { useDataChange } from 'Simple/Data.js'

import { dateShortOut } from 'Data/format.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let changeSelected = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })
  return function onChange(value, change) {
    // sync up the value
    changeSelected(next => {
      next.selected.next_appointment.from_date = dateShortOut(value.from)
      next.selected.next_appointment.to_date = dateShortOut(value.to)
    })
  }
}
